import request from '@/utlis/request'
export function login(data) {
    return request({
        url: '/admin/sysuser/auth/login',
        method: 'post',
        data
    })
}